import React from "react";
import useWizardPage from "./useWizardPage";

/**
 * Default WelcomePage Component - Automatically shown as the first page
 */
const WelcomePage = () => {
    const { inputManifest, emittedManifest } = useWizardPage();

    return (
        <div>
            <div className="alert alert-info">
                <h4 className="alert-heading">
                    <i className="fa fa-magic mr-2"></i>
                    Welcome to the Wizard
                </h4>
                <p className="mb-0">
                    This wizard will guide you through the configuration process
                    step by step. Click <strong>Next</strong> to begin.
                </p>
            </div>

            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">
                        <i className="fa fa-info-circle mr-2 text-info"></i>
                        Getting Started
                    </h5>
                    <p className="card-text">
                        Follow the steps in the wizard to complete your
                        configuration. You can navigate back and forth between
                        steps using the
                        <strong> Back</strong> and <strong>Next</strong>{" "}
                        buttons.
                    </p>
                    <hr />
                    <h6 className="text-muted mb-3">
                        <i className="fa fa-list mr-2"></i>
                        What to expect:
                    </h6>
                    <ul className="mb-0">
                        <li>Complete each step in order</li>
                        <li>Review your configuration at the end</li>
                        <li>Make changes if needed before finishing</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default WelcomePage;
